import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {BrandingApiService} from '../../../../../projects/api/src/branding/branding-api.service';
import {ConfigureService} from '../../../../../projects/common/modules/configure/configure.service';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-header-logo',
    templateUrl: './header-logo.component.html',
    styleUrls: ['./header-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule]
})
export class HeaderLogoComponent implements  OnInit {

  @Input() prefix: string;
  showDefaultLogo = false;
  logoImageUrl = null;

  constructor(private brandingApi: BrandingApiService, private cdRef: ChangeDetectorRef, private configService: ConfigureService) {
  }

  ngOnInit() {
    this.setDefaultLogoImage();
  }

  setDefaultLogoImage() {

    if (this.configService.options.appConfig.logoUrl) {
      this.logoImageUrl = this.configService.options.appConfig.logoUrl;
    }

    this.brandingApi.isExist('headerLogo').subscribe(data => {
        if (data) {
          this.logoImageUrl = this.brandingApi.makeImageUrl('headerLogo');
          this.showDefaultLogo = false;
          this.cdRef.detectChanges();
        } else {
          this.showDefaultLogo = true;
        }
      }, error => {
        this.showDefaultLogo = true;
        console.log(error);
      }
    );
  }
}
